// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingAnalytics_DashboardSummaryResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/messaging_analytics/dashboard_summary
 *
 * Returns the active filter period, aggregated totals, and a per-device
 * breakdown of messaging KPIs (WhatsApp + Instagram).
 */
import type { MessagingAnalytics_DashboardSummaryDeviceRow } from './MessagingAnalytics_DashboardSummaryDeviceRow'
import type { MessagingAnalytics_DashboardSummaryPeriodoRow } from './MessagingAnalytics_DashboardSummaryPeriodoRow'
import type { MessagingAnalytics_DashboardSummaryTotaisRow } from './MessagingAnalytics_DashboardSummaryTotaisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingAnalytics_DashboardSummaryResponseDados {
periodo: MessagingAnalytics_DashboardSummaryPeriodoRow
totais: MessagingAnalytics_DashboardSummaryTotaisRow
por_dispositivo: MessagingAnalytics_DashboardSummaryDeviceRow[]
}

export type MessagingAnalytics_DashboardSummaryResponse = ApiResponse<MessagingAnalytics_DashboardSummaryResponseDados>;

registerResponseContract('MessagingAnalytics_DashboardSummaryResponse', {
  periodo: {
    type: 'object',
    required: true,
    fields: {
      inicio: { type: 'string',  required: false },
      fim:    { type: 'string',  required: false },
    },
  },
  totais: {
    type: 'object',
    required: true,
    fields: {
      mensagens_enviadas:  { type: 'number',  required: false },
      mensagens_recebidas: { type: 'number',  required: false },
      conversas_ativas:    { type: 'number',  required: false },
      chats_sem_resposta:  { type: 'number',  required: false },
      chats_nao_lidos:     { type: 'number',  required: false },
      total_chats:         { type: 'number',  required: false },
      score_geral:         { type: 'number',  required: false },
    },
  },
  por_dispositivo: {
    type: 'array',
    required: true,
    items: {
      whatsappfranquia_id: { type: 'number',  required: false },
      device_id:           { type: 'number',  required: false },
      device_name:         { type: 'string',  required: false },
      provider_type:       { type: 'string',  required: false },
      franquias:           { type: 'string',  required: false },
      connection_status:   { type: 'string',  required: false },
      mensagens_enviadas:  { type: 'number',  required: false },
      mensagens_recebidas: { type: 'number',  required: false },
      chats_sem_resposta:  { type: 'number',  required: false },
      chats_nao_lidos:     { type: 'number',  required: false },
      total_chats:         { type: 'number',  required: false },
      score_performance:   { type: 'number',  required: false },
    },
  },
})
